import React from "react";
import { DRINKS, usd } from "./coffeeUi";
function Trend({ data, field, title, monetary = false }) {
  if (!data.length)
    return (
      <section>
        <h2>{title}</h2>
        <p>Sin datos para este período.</p>
      </section>
    );
  const max = Math.max(1, ...data.map((row) => row[field]));
  const point = (row, i) =>
    `${data.length === 1 ? 300 : 30 + (i * 540) / (data.length - 1)},${
      150 - (row[field] / max) * 120
    }`;
  return (
    <section>
      <h2>{title}</h2>
      <svg
        className="coffee-trend"
        viewBox="0 0 600 180"
        role="img"
        aria-label={`${title} por fecha de cierre`}
      >
        <line x1="30" x2="570" y1="150" y2="150" stroke="#cbd5e1" />
        <text x="30" y="18">
          {monetary ? usd(max) : max}
        </text>
        <text x="16" y="154" textAnchor="end">
          0
        </text>
        <polyline
          points={data.map(point).join(" ")}
          fill="none"
          stroke="#256c59"
          strokeWidth="3"
        />
        {data.map((row, i) => {
          const [cx, cy] = point(row, i).split(",");
          return (
            <circle key={row._id} cx={cx} cy={cy} r="4" fill="#256c59">
              <title>
                {row._id}: {monetary ? usd(row[field]) : row[field]}
              </title>
            </circle>
          );
        })}
        <text x="30" y="174">
          {data[0]._id}
        </text>
        <text x="570" y="174" textAnchor="end">
          {data[data.length - 1]._id}
        </text>
      </svg>
      <details>
        <summary>Ver valores por fecha</summary>
        <div className="coffee-table-wrap">
          <table className="coffee-table">
            <thead>
              <tr>
                <th>Cierre</th>
                <th>{title}</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row) => (
                <tr key={row._id}>
                  <td>{row._id}</td>
                  <td>{monetary ? usd(row[field]) : row[field]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </details>
    </section>
  );
}
export default function CoffeeCharts({ report }) {
  const max = Math.max(1, ...report.drinks.map((row) => row.quantity));
  return (
    <>
      <div className="coffee-chart-grid">
        <Trend
          title="Evolución del consumo"
          field="consumption"
          data={report.trend}
        />
        <Trend
          title="Evolución de ventas · USD"
          field="salesCents"
          monetary
          data={report.trend}
        />
      </div>
      <section>
        <h2>Bebidas reportadas</h2>
        <div className="coffee-drink-chart">
          {DRINKS.map((label, i) => {
            const item = report.drinks.find((row) => row._id === i);
            return (
              <div className="coffee-drink-row" key={label}>
                <span>{label}</span>
                <div className="coffee-bar-track">
                  <div
                    style={{ width: `${((item?.quantity || 0) / max) * 100}%` }}
                  />
                </div>
                <strong>
                  {item?.reported ? item.quantity : "Sin reportar"}
                </strong>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
}
